(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var bar = null;
  var stickyButton = null;
  var sourceButton = null;
  var visibilityObserver = null;
  var buttonObserver = null;

  function sourceLabel() {
    var label = sourceButton.querySelector('span');
    return (label ? label.textContent : sourceButton.textContent).replace(/\s+/g, ' ').trim();
  }

  function syncButton() {
    if (!sourceButton || !stickyButton) return;
    stickyButton.textContent = sourceLabel();
    stickyButton.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
  }

  function setVisible(isVisible) {
    if (!bar) return;
    var show = mobileQuery.matches && isVisible;
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('has-mobile-sticky-atc', show);
  }

  function watchButton() {
    if (visibilityObserver) visibilityObserver.disconnect();
    if (buttonObserver) buttonObserver.disconnect();
    if (!sourceButton || !mobileQuery.matches) {
      setVisible(false);
      return;
    }

    visibilityObserver = new IntersectionObserver(
      function (entries) {
        setVisible(!entries[0].isIntersecting);
      },
      { threshold: 0.15 }
    );
    visibilityObserver.observe(sourceButton);

    buttonObserver = new MutationObserver(syncButton);
    buttonObserver.observe(sourceButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });
    syncButton();
  }

  function init() {
    sourceButton = document.querySelector('product-info .product-form__submit[name="add"][data-mobile-sticky="true"]');
    if (!sourceButton) {
      if (bar) bar.remove();
      bar = null;
      stickyButton = null;
      document.body.classList.remove('has-mobile-sticky-atc');
      return;
    }

    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'mobile-sticky-atc';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Add to cart');
      stickyButton = document.createElement('button');
      stickyButton.type = 'button';
      stickyButton.className = 'button button--primary mobile-sticky-atc__button';
      stickyButton.addEventListener('click', function () {
        if (!sourceButton || stickyButton.disabled) return;
        sourceButton.click();
      });
      bar.appendChild(stickyButton);
      document.body.appendChild(bar);
    }

    watchButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', watchButton);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(watchButton);
  }
})();
